import useAppSelector from "@/core/helpers/useAppSelector";
import { stationSelector } from "@/domains/gasStation/slice";
import GasStationLocation from "@/domains/gasStation/components/GasStationLocation";

export default function GasStationLocationContainer() {
  const station = useAppSelector(stationSelector);

  return <GasStationLocation location={`${station.address.streetName} ${station.address.index}`} />;
}
